import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

import { Button, Form, Grid, Header, Image, Message, Segment, Input } from 'semantic-ui-react';
import logoImg from '../../../Assets/Images/DDS_Logo.jpg';
import { useForgetPasswordForm } from './useForgetPasswordForm';

const ForgetPasswordForm = () => {

  const [values, errors, touched, isLoading, isSubmitting, isValid, errorMessage, registerRef, handleChange, handleBlur, handleSubmit] = useForgetPasswordForm();
  function handleSubmitData() {
    handleSubmit();
  }

  //console.log(errors);
  const errorText: string[] = [];
  Object.keys(errors).forEach((key)=>{
    errorText.push(errors[key]);
  })
  return (
    <Grid textAlign='center' style={{ marginTop: '10rem' }} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450, minWidth: "8px" }}>
        <Form size='large' loading={isSubmitting}>
          <Segment stacked textAlign='center'>
            <Image src={logoImg} alt='DDS Logo' centered />
            <Header as='h2' color='black' textAlign='center'>
              DC Department on Disability Services Virtual Resource Room
            </Header>
            <Header as='h3' color='black' textAlign='center'>
              Reset your password though email
            </Header>
            <Form.Input 
            required
            fluid icon='mail' iconPosition='left' placeholder='example@abc.com'
              onChange={(event, data) => {
                handleChange(data.value, 'email');
              }}
              onBlur={
                () => { handleBlur('email') }
              }
              error={!(!errors.email || !touched.email) ? true : false}

            />
            <Button 
              type='button'
              onClick={handleSubmitData}
            color='blue' fluid size='large'>
              Send a reset password request
            </Button>

            {
              errorMessage != null &&
              <Message
                negative
                header='Something goes wrong:'
                content={errorMessage}
              />
            }
            {
              Object.keys(errors).length > 0 &&
              <Message
                negative
                list={errorText}
              />
            }
          </Segment>
        </Form>


        <Message>
          Already have new password? <Link to='/login'>Login</Link>
        </Message>
      </Grid.Column>
    </Grid>
  )
}

export default ForgetPasswordForm